import {
  useFetchLabels,
  useFetchLabelsCategories,
  useFetchLabelsCategory
} from '@/hooks/queries/labels';
import { LabelsCategories } from '@/models/labels';

import { PendingLabel } from '../types';
import { isSameName } from '../utils/matching';
import { buildGroupedOption } from '../utils/options';

export const useLabelCatalog = (
  isPickerOpen: boolean,
  isUnavailable: (id: number) => boolean
) => {
  const { data: catalog } = useFetchLabels({});
  const { data: catalogCategories } = useFetchLabelsCategories({});

  const categoryIds = (catalogCategories?.results ?? []).map((c) => c.id);
  const categoryQueries = useFetchLabelsCategory(categoryIds, isPickerOpen);

  const categoryDetails = categoryQueries
    .map((q) => q.data)
    .filter((d): d is LabelsCategories.Detail => Boolean(d))
    .sort((a, b) => a.name.localeCompare(b.name));

  const catalogLabels: PendingLabel[] = catalog?.results ?? [];
  const { groupedOptions, categoryBadges } = buildGroupedOption(
    categoryDetails,
    catalogLabels,
    isUnavailable
  );

  return {
    catalogLabels,
    groupedOptions,
    categoryBadges,
    findCategoryName: (name: string) =>
      catalogCategories?.results.find((c) => isSameName(c.name, name)),
    findLabelName: (name: string) =>
      catalogLabels.find((l) => isSameName(l.name, name)),
    isLabelLinkedCategory: (categoryId: number, labelId: number) =>
      categoryDetails
        .find((c) => c.id === categoryId)
        ?.labels.some((l) => l.id === labelId) ?? false
  };
};
